<template>
  <div>
    <headers />
    <div class="head">
      <img src="@/assets/images/productManualBj.png" />
      <div class="title">产品手册</div>
      <div class="searchBox">
        <search @search="searchFun" :type="2" />
      </div>
      <!-- <div class="title2">
        发现下载安装新版本所需的所有项目内容，
        每个发布版本都将以软件包的形式提供下载。
      </div> -->
    </div>

    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资料获取</el-breadcrumb-item>
        <el-breadcrumb-item>产品手册</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content">
      <div class="leftBox">
        <!-- 顶级全量分类：全部产品（点击默认不传 classifyId 查询全部） -->
        <div class="all-product-menuBox" @click="selectALLProducts">
          <div class="all-product-item" :class="{ active: actId === '' }">
            <div class="all-product-title">全部产品</div>
          </div>
        </div>

        <div class="menuBox" v-for="(item, index) in menuList" :key="index">
          <!-- 一级分类 -->
          <div class="menuItem" @click="actMenuOne(item)">
            <div class="menuItemL">{{ item.name }}</div>
            <div class="menuItemR">
              <i
                :style="actOneMeun == item.id ? 'color:#00D8C3' : ''"
                :class="
                  actOneMeun == item.id
                    ? 'el-icon-arrow-up'
                    : 'el-icon-arrow-right'
                "
              ></i>
            </div>
          </div>

          <!-- 二级分类容器 -->
          <div class="menuCellBox" v-if="actOneMeun == item.id">
            <div
              class="menuSubBox"
              v-for="(subItem, subIndex) in item.children"
              :key="subIndex"
            >
              <!-- 二级分类标题行 -->
              <div class="subMenuItem" @click="actMenuTwo(subItem)">
                <div
                  class="subMenuItemL textOverflowOne"
                  :class="{
                    active:
                      actId == subItem.id &&
                      (!subItem.children || !subItem.children.length),
                  }"
                >
                  {{ subItem.name }}
                </div>
                <div
                  class="subMenuItemR"
                  v-if="subItem.children && subItem.children.length"
                >
                  <i
                    :style="actTwoMenu == subItem.id ? 'color:#00D8C3' : ''"
                    :class="
                      actTwoMenu == subItem.id
                        ? 'el-icon-arrow-up'
                        : 'el-icon-arrow-right'
                    "
                  ></i>
                </div>
              </div>

              <!-- 三级分类列表 -->
              <div
                class="menuSubCellBox"
                v-if="
                  actTwoMenu == subItem.id &&
                  subItem.children &&
                  subItem.children.length
                "
              >
                <!-- 全部选项 -->
                <div
                  class="menuCellItem textOverflowOne"
                  @click.stop="changeItem(subItem)"
                  :class="{ active: actId == subItem.id }"
                >
                  全部
                </div>
                <!-- 三级具体分类 -->
                <div
                  class="menuCellItem textOverflowOne"
                  v-for="(subSubItem, subSubIndex) in subItem.children"
                  @click.stop="changeItem(subSubItem)"
                  :key="subSubIndex"
                  :class="{ active: actId == subSubItem.id }"
                >
                  {{ subSubItem.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <!-- <div class="searchBox">
          <search @search="searchFun" />
        </div> -->
        <template v-if="list.length">
          <div class="card">
            <div class="cardItem" v-for="(item, index) in list" :key="index">
              <div class="imgBox">
                <img class="hoverTransform" :src="item.image" />
              </div>

              <div class="title textOverflowOne">
                {{ item.name }}
              </div>

              <div class="titleDetails textOverflowTwo" :title="item.breif">
                {{ item.breif }}
              </div>

              <div class="btnBox">
                <div>浏览：{{ item.readNum }}</div>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-document"
                  class="searchBoxR"
                  @click="toDetails(item)"
                >
                  查看资料
                </el-button>
              </div>
            </div>
          </div>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pages.total"
              :page-size="pages.size"
              :current-page="pages.page"
              @current-change="currentChange"
            >
            </el-pagination>
          </div>
        </template>
        <None v-else />
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";

import { productClassifyList, productList } from "@/api/lx";
import ToolDetails from "./toolDetails.vue";

export default {
  name: "productManual",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      actOneMeun: 0,
      actTwoMenu: 0,
      actId: "",
      menuList: [],
      searchValue: "",
      pages: {
        page: 1,
        total: 0,
        size: 12,
      },
      list: [],
    };
  },
  created() {
    this.getProductClassifyList();
  },
  mounted() {},
  methods: {
    /**
     * 搜索关键词更新并重置页码获取列表
     * @param {string} val - 搜索关键字
     * @returns {void}
     */
    searchFun(val) {
      this.searchValue = val;
      this.pages.page = 1;
      this.getList();
    },

    /**
     * 页码变更回调
     * @param {number} val - 目标页码
     * @returns {void}
     */
    currentChange(val) {
      this.pages.page = val;
      this.getList();
    },

    /**
     * 选中全部产品分类，清空 classifyId 查询全量产品数据
     * @returns {void}
     */
    selectALLProducts() {
      this.actId = "";
      this.actOneMeun = "";
      this.actTwoMenu = "";
      this.pages.page = 1;
      this.getList();
    },

    /**
     * 获取产品三级分类树形数据，默认选中全部产品（不传 classifyId）查询全部数据
     * @returns {void}
     */
    getProductClassifyList() {
      productClassifyList({}).then((res) => {
        this.menuList = res.data || [];
        // 默认选中全部产品
        this.actId = "";
        this.actOneMeun = "";
        this.actTwoMenu = "";
        this.getList();
      });
    },

    /**
     * 分页查询产品列表数据
     * @returns {void}
     */
    getList() {
      productList({
        page: this.pages.page,
        size: this.pages.size,
        name: this.searchValue,
        classifyId: this.actId,
      }).then((res) => {
        this.list = res.data.records;
        this.pages.total = res.data.total;
      });
    },

    /**
     * 选中分类（三级分类或二级“全部”分类）并查询列表
     * @param {Object} item - 选中的分类对象
     * @returns {void}
     */
    changeItem(item) {
      this.actId = item.id;
      this.pages.page = 1;
      this.getList();
    },

    /**
     * 切换一级分类展开/折叠状态
     * @param {Object} val - 一级分类对象
     * @returns {void}
     */
    actMenuOne(val) {
      if (this.actOneMeun == val.id) {
        this.actOneMeun = "";
      } else {
        this.actOneMeun = val.id;
      }
    },

    /**
     * 切换二级分类展开/折叠状态（若无子分类则直接选中该分类）
     * @param {Object} val - 二级分类对象
     * @returns {void}
     */
    actMenuTwo(val) {
      if (val.children && val.children.length > 0) {
        if (this.actTwoMenu == val.id) {
          this.actTwoMenu = "";
        } else {
          this.actTwoMenu = val.id;
        }
      } else {
        this.changeItem(val);
      }
    },

    /**
     * 跳转到产品手册详情页
     * @param {Object} item - 选中的产品数据对象
     * @returns {void}
     */
    toDetails(item) {
      this.$router.push({
        path: "/information/productManualDetails",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 300px;
  position: relative;
  overflow: hidden;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: #ffffff;
    position: relative;
    z-index: 10;
    width: 100%;
    text-align: center;
    margin-top: 60px;
  }
  .title2 {
    width: 400px;
    height: 56px;
    margin: 0 auto;
    text-align: center;
    margin-top: 35px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
    font-style: normal;
    position: relative;
    z-index: 10;
  }
}
.content {
  width: 100%;
  display: flex;
  margin-top: 0px;
}
.leftBox {
  width: 477px;

  .all-product-menuBox {
    width: 393px;
    margin-left: 45px;
    padding: 16px 30px 16px 0px;
    box-sizing: border-box;
    cursor: pointer;

    .all-product-item {
      display: flex;
      width: 100%;
      align-items: center;
      font-weight: 600;
      font-size: 18px;
      color: #00161a;
      padding: 4px 0;
      transition: color 0.2s ease;

      &:hover,
      &.active {
        color: #00d8c3;
      }
    }
  }

  .menuBox {
    width: 393px;
    margin-left: 45px;
    padding: 16px 30px 16px 0px;
    box-sizing: border-box;
    border-top: 1px solid #e6edf0;
    cursor: pointer;

    .menuItem {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 18px;
      color: #00161a;
      padding: 4px 0;
    }

    .menuCellBox {
      padding-top: 8px;
      margin-top: 8px;
      padding-left: 12px;
      box-sizing: border-box;

      .menuSubBox {
        margin-top: 12px;

        &:first-child {
          margin-top: 4px;
        }

        .subMenuItem {
          display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: center;
          font-size: 15px;
          font-weight: 500;
          color: #2c3e50;
          line-height: 24px;
          padding: 4px 0;
          transition: color 0.2s ease;

          &:hover {
            color: #00d8c3;
          }

          .subMenuItemL.active {
            color: #00d8c3;
            font-weight: 600;
          }
        }

        .menuSubCellBox {
          margin-top: 6px;
          margin-left: 4px;
          margin-bottom: 8px;
          padding-left: 16px;
          border-left: 2px solid #eef3f6;
          box-sizing: border-box;

          .menuCellItem {
            font-size: 13.5px;
            color: #525f66;
            line-height: 20px;
            padding: 6px 0;
            transition: all 0.2s ease;

            &:hover {
              color: #00d8c3;
            }

            &.active {
              color: #00d8c3;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
.rightBox {
  width: calc(100vw - 477px);
  margin-top: 15px;
}
.searchBox {
  margin-bottom: 20px;
}
.card {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .cardItem {
    width: 330px;
    margin-right: 26px;
    margin-bottom: 26px;
    padding: 16px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #eef3f6;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);

    &:hover {
      box-shadow: 0 12px 32px rgba(0, 216, 195, 0.12);
      transform: translateY(-4px);

      .imgBox img {
        transform: scale(1.06);
      }

      .title {
        color: #00d8c3;
      }
    }

    .imgBox {
      width: 298px;
      height: 298px;
      border: 1px solid #f0f4f7;
      border-radius: 8px;
      overflow: hidden;
      background: #ffffff;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        transition: transform 0.4s ease;
      }
    }

    .title {
      font-weight: 600;
      font-size: 18px;
      color: #00161a;
      margin-top: 15px;
      transition: color 0.3s ease;
    }

    .titleDetails {
      font-weight: 400;
      font-size: 14px;
      height: 40px;
      line-height: 20px;
      color: #525f66;
      text-align: left;
      margin-top: 10px;
    }

    .btnBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;

      div {
        font-weight: 400;
        font-size: 14px;
        color: #525f66;
      }

      .searchBoxR {
        width: 108px;
        height: 36px;
        line-height: 36px;
        padding: 0;
        border-radius: 18px;
        background: linear-gradient(135deg, #00d8c3 0%, #00c2b0 100%);
        border: none;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #ffffff;
        transition: all 0.3s ease;

        &:hover,
        &:focus {
          background: linear-gradient(135deg, #00e6d0 0%, #00b3a2 100%);
          transform: translateY(-1px);
          color: #ffffff;
        }
      }
    }
  }
}
.page {
  margin-left: 233px;
  margin-bottom: 55px;
}
.searchBox {
  margin-top: 54px;
}
</style>